module.exports = __webpack_public_path__ + "static/media/chatBg.cdd8fc88.png";